/**
 * Typed re-exports of shadcn .jsx components so call sites get an `any` type
 * (matching how Button/Input/Card are surfaced via shadcn.d.ts). This avoids
 * TS inferring narrow forwardRef signatures that don't include `children` /
 * `data-testid` / `className`, which it does when allowJs reads the .jsx
 * directly.
 */
import * as DialogModule from "@/components/ui/dialog";
import * as SheetModule from "@/components/ui/sheet";
import * as TextareaModule from "@/components/ui/textarea";

const D: any = DialogModule;
const S: any = SheetModule;
const T: any = TextareaModule;

export const Dialog: any = D.Dialog;
export const DialogContent: any = D.DialogContent;
export const DialogHeader: any = D.DialogHeader;
export const DialogFooter: any = D.DialogFooter;
export const DialogTitle: any = D.DialogTitle;
export const DialogDescription: any = D.DialogDescription;

export const Sheet: any = S.Sheet;
export const SheetContent: any = S.SheetContent;
export const SheetHeader: any = S.SheetHeader;
export const SheetTitle: any = S.SheetTitle;

export const Textarea: any = T.Textarea;

import * as PopoverModule from "@/components/ui/popover";
import * as CommandModule from "@/components/ui/command";
const P: any = PopoverModule;
const C: any = CommandModule;
export const Popover: any = P.Popover;
export const PopoverTrigger: any = P.PopoverTrigger;
export const PopoverContent: any = P.PopoverContent;
export const Command: any = C.Command;
export const CommandEmpty: any = C.CommandEmpty;
export const CommandGroup: any = C.CommandGroup;
export const CommandInput: any = C.CommandInput;
export const CommandItem: any = C.CommandItem;
export const CommandList: any = C.CommandList;
